import { styled } from '@material-ui/core'
import { Button } from '@material-ui/core'
import Colors from '../../../../../constants/Colors'

export const CancelButton = styled(Button)({
  borderColor: Colors.PRIMARY_COLOR,
  color: Colors.PRIMARY_COLOR,
  padding: '8px 16px 8px 16px',
})
